export default {
    'dashboard.analysis.timeLabel': 'Time',
    'dashboard.analysis.timeToday': 'Today',
    'dashboard.analysis.timeWeek': 'This Week',
    'dashboard.analysis.timeMonth': 'This Month',
    'dashboard.analysis.timeYear': 'This Year',
    'dashboard.analysis.operation1': 'Operation 1',
    'dashboard.analysis.operation2': 'Operation 2',
};
